<template>
  <div class="auth-wrapper">
    <img src="@/assets/logo-hpu-ftugm.png" class="logo" alt="Logo HPU FT-UGM" />
    <!-- Information -->
    <p align="center" class="mt-1 mb-5 text-official">
      Silakan masuk dengan akun E-mail UGM Anda. Terkhusus bagi Anda yang sudah
      pernah mengikuti Posbindu, dapat menggunakan akun E-mail Gmail yang
      digunakan saat pendaftaran.
    </p>
    <pulse-loader :loading="isLoading" size="10px" :color="colorPrimary" />
    <!-- Google Login -->
    <div
      v-if="!isLoading"
      class="btn-google-login"
      id="google-login-btn"
      v-google-identity-login-btn="gIndentityParams"
    >
      Sign in with Google
    </div>
    <footer class="copyright">
      &copy; Fakultas Teknik Universitas Gadjah Mada
    </footer>
  </div>
</template>

<script>
import GoogleSignInButton from "vue-google-identity-login-btn";
import { googleClientId } from "@/config/google";

export default {
  name: "auth",
  directives: {
    GoogleSignInButton,
  },
  data: function () {
    return {
      form: {
        token: "",
      },
      gIndentityParams: {
        clientId: googleClientId,
        locale: "id-ID",
        shape: "circle",
        size: "medium",
        width: 300,
      },
      isLoading: false,
    };
  },
  methods: {
    onGoogleAuthSuccess(jwtCredentials) {
      this.form.token = jwtCredentials;

      this.doLogin();
    },
    doLogin: function () {
      this.isLoading = true;
      this.$store
        .dispatch("login", this.form)
        .then(() => {
          if (!this.$store.getters.completedRegistration) {
            this.$router.replace({ name: "profile-settings" });
          } else if (!this.$store.getters.isOfficialEmail) {
            this.$router.replace({ name: "change-email" });
          } else {
            this.$router.replace({ name: "home" });
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$toasted.error("Maaf, Anda belum memiliki akses.", {
            containerClass: ["custom-toast-container", "no-top-space"],
          });
        });
    },
    resetValidations: function () {
      this.validations.username.error = false;
      this.validations.password.error = false;
    },
    isError: function () {
      return this.validations.username.error || this.validations.password.error;
    },
  },
};
</script>
